// extracted by mini-css-extract-plugin
export default {"container":"listSection_container__Avug0"};